export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.6.30-1309.25",
  commitId: "e179bc63ad2637bd0ec4d67c00159f54570ccf54",
  commitTime: "2026-06-30T13:09:25.000Z",
});
